import { useCallback, useState } from 'react'

export function useElementSize<T extends HTMLElement>() {
  const [size, setSize] = useState({ width: 0, height: 0 })

  const ref = useCallback((node: T | null) => {
    if (!node) return

    const rect = node.getBoundingClientRect()
    setSize({ width: rect.width, height: rect.height })

    const observer = new ResizeObserver(([entry]) => {
      const { width, height } = entry.contentRect
      setSize({ width, height })
    })

    observer.observe(node)

    return () => observer.disconnect()
  }, [])

  return { ref, size }
}
